var _path, _circle, _g, _use, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 600,
    viewBox: "-225 -114 450 300",
    width: 900,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-225-114h450v300h-450z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ce1126",
    r: 64.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0c-2.167 0-3 3.25-3 6.5 0 7.833.96 11.929 3 23.5C2.04 18.429 3 14.333 3 6.5 3 3.25 2.167 0 0 0z",
    fill: "#ce1126",
    transform: "translate(0 -102)"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(5)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(10)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(20)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(40)",
    xlinkHref: "#d"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-80)",
    xlinkHref: "#e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-225-21.5h450V186h-450z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-225-14h450v200h-450z",
    fill: "#ce1126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-225 86h450v100h-450z",
    fill: "#339e35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/mw.43c6abc22538d807bdb3d18e30db2329.svg";
export { ForwardRef as ReactComponent };